import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NotifyService } from '../services/notify.service';

@Injectable({
  providedIn: 'root'
})
export class ExplorerGuard implements CanActivate {
  constructor(
    private _userS: UserService,
    private notify: NotifyService,
    private route: Router
  ) { }
  canActivate() {
    // if (this._userS.getTokenDetails.User_Role === "EXPLORER") {
    //   return true
    // } else {
    //   this.notify.error('Unauthorized', 'You are not allowed')
    //   this.route.navigateByUrl('/login')
    //   localStorage.clear()
    //   return false;
    // }
    return true;
  }

}
